import { AxiosResponse } from 'axios'
import _ from 'lodash'
import { Pager, PagerHeader } from './pager.types'

type responseType = 'json' | 'csv' | 'unknown'
interface MultipartResponse {
  // レスポンスタイプ
  type: responseType,
  // パースしたヘッダ（keyとvalueのハッシュ形式でオブジェクト化）
  headers: Object,
  // responseのtypeに則したbody。unknownの場合はそのまま
  body: Object|string,
  // responseTypeによってはoption情報を返す
  options: {
    // 文字コード
    charset?: string,
  },
}

export const multipartParser = (httpRawResponse: string): MultipartResponse[] => {
  const boundary = _.chain(httpRawResponse).split('\n').first().value()
  const rawResponses = _.chain(httpRawResponse).split(boundary).drop().value()
  const responses = rawResponses.map((rawHttp) => {
    const [rawHeader, rawBody] = rawHttp.split('\r\n\r\n')

    const headers = _.chain(rawHeader)
      .split(/\r|\n/)
      .compact()
      .drop() // http status line
      .reduce((carry, line) => {
        const [key, ...val] = line.split(':')
        // @ts-expect-error 型チェック不要部分
        return _.set(carry, key, _.trim(val))
      }, {})
      .value()

    const contentType = _.get(headers, 'Content-Type')
    let type: responseType = 'unknown'
    let body = rawBody
    let options = {}

    if (contentType === 'application/json') {
      type = 'json'
      body = JSON.parse(rawBody)
    } else if (/^text\/csv/.test(contentType)) {
      type = 'csv'
      const [, charset] = contentType.match(/charset=([^ ]+)/)
      options = _.set(options, 'charset', charset)
    }
    return {
      type,
      headers,
      body,
      options,
    }
  })

  return responses
}

/**
 * APIレスポンスからページャーを取得
 *
 * @param {number} current 現在のページ番号
 * @param {PagerHeader} headers APIからのレスポンスヘッダ
 */
export const getPagerFromApiResponse = (current: number, headers: PagerHeader | any): Pager => ({
  current,
  last: _.chain(headers).get('x-paginate-last').toNumber().value(),
  totalLength: _.chain(headers).get('x-paginate-total').toNumber().value(),
})
